/**
 * Normaliza y determina si un pathname corresponde a una ruta pública accesible sin sesión activa.
 * 
 * Insensible a mayúsculas/minúsculas y soporta parámetros/tokens en el path.
 * 
 * @param {string} pathname
 * @returns {boolean}
 */
export const isPublicRoute = (pathname) => {
  if (!pathname || typeof pathname !== 'string') {
    return false;
  }

  // Normalizar: remover trailing slash y pasar a minúsculas
  const normalized = pathname.trim().toLowerCase().replace(/\/+$/, '') || '/';

  // Rutas con coincidencia exacta
  const exactPublicRoutes = [
    '/login',
    '/register',
    '/forgot-password',
    '/reset-password',
    '/services',
  ];

  if (exactPublicRoutes.includes(normalized)) {
    return true;
  }

  // Rutas con prefijo (que contienen tokens o parámetros dinámicos)
  const prefixPublicRoutes = [
    '/resetpassword',
    '/createpassword',
    '/verificatecodeemail',
  ];

  return prefixPublicRoutes.some((prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`));
};
